"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _core = require("core.ui-module_site-components");
var _OtpVerificationResponse = _interopRequireDefault(require("../../api/auth/OtpVerificationResponse"));
var _ApplicationContext = require("../../api/ApplicationContext");
var _ResendSecurityCodeLink = _interopRequireDefault(require("./ResendSecurityCodeLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const decorateErrorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger has-text-left"
}, msg);
class OtpVerificationStep extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "triggerKba", e => {
      e.preventDefault();
      this.setState({
        errorMessage: '',
        isLoading: true
      });
      const step = new _OtpVerificationResponse.default();
      step.neverReceivedCode = true;
      this.props.listener(this, step);
    });
    this.state = {
      isLoading: false,
      resendRequested: false,
      otpCode: '',
      errorMessage: ''
    };
    this.returnToLogin = this.returnToLogin.bind(this);
    this.resend = this.resend.bind(this);
  }
  submit(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _OtpVerificationResponse.default();
    step.resendRequested = this.state.resendRequested;
    step.otpCode = this.state.otpCode;
    this.props.listener(this, step);
  }
  change(e) {
    const otpCode = e.target.value;
    if (!this.validateLength(otpCode)) {
      this.setState({
        otpCode,
        errorMessage: 'This field is required for submission'
      });
    } else if (!this.validateNumber(otpCode)) {
      this.setState({
        otpCode,
        errorMessage: 'This field must be numeric'
      });
    } else {
      this.setState({
        otpCode,
        errorMessage: null
      });
    }
  }
  validate(otpCode) {
    return this.validateLength(otpCode) && this.validateNumber(otpCode);
  }
  validateLength(otpCode) {
    return otpCode && otpCode.length > 0;
  }
  validateNumber(otpCode) {
    return /^\d+$/.test(otpCode);
  }
  resend(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _OtpVerificationResponse.default();
    step.resendRequested = true;
    this.props.listener(this, step);
  }
  returnToLogin(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    this.props.listener('InitializeAuthentication', null);
    this.props.history.push(_ApplicationContext.ApplicationContext.getLoginPath());
  }
  render() {
    var _stepResponse$additio, _stepResponse$additio2;
    const {
      otpCode,
      rawErrorMessage,
      isLoading,
      message
    } = this.state;
    const {
      stepResponse
    } = this.props;
    var allowKbaLink = (stepResponse === null || stepResponse === void 0 || (_stepResponse$additio = stepResponse.additionalData) === null || _stepResponse$additio === void 0 ? void 0 : _stepResponse$additio.kbaAllowed) || false;

    // Dynamic message that says where otp was sent
    const deliveryMethodMessage = (stepResponse === null || stepResponse === void 0 || (_stepResponse$additio2 = stepResponse.additionalData) === null || _stepResponse$additio2 === void 0 ? void 0 : _stepResponse$additio2.message) || message || 'If the email address that you provided is valid, you will receive an email containing a one-time security code.';
    const placeHolder = '6 Digit Security Code';
    const disabled = !this.validate(otpCode) && !rawErrorMessage;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement("form", {
      id: "otpForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title",
      dangerouslySetInnerHTML: {
        __html: _ApplicationContext.ApplicationContext.getSecurityCodeTitle() ? _dompurify.default.sanitize(_ApplicationContext.ApplicationContext.getSecurityCodeTitle()) : 'Security Code'
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle has-text-left pb-4"
    }, deliveryMethodMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${rawErrorMessage && 'is-danger'}`,
      type: "text",
      min: "0",
      max: "99999999",
      placeholder: placeHolder,
      id: "otpCode",
      name: "otpCode",
      size: "15",
      onChange: e => this.change(e),
      onBlur: e => this.change(e),
      value: otpCode,
      autoComplete: "one-time-code",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), decorateErrorMessage(rawErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Next"))), /*#__PURE__*/_react.default.createElement(_ResendSecurityCodeLink.default, {
      returnToLogin: this.returnToLogin,
      resend: this.resend,
      kbaAllowed: allowKbaLink,
      triggerKba: this.triggerKba
    })))));
  }
}
OtpVerificationStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  stepResponse: _propTypes.default.shape({
    additionalData: _propTypes.default.shape({
      message: _propTypes.default.string
    })
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(OtpVerificationStep);
//# sourceMappingURL=OtpVerificationStep.js.map